import { z } from "zod";
import { EUserSuspendMode } from "@/utilities/types/suspension";

export const UserSuspendUpdateDTOSchema = z
  .object({
    mode: z.nativeEnum(EUserSuspendMode),
    reason: z.string().optional(),
    date: z.date().optional(),
  })
  .refine(
    (data) => {
      if (data.mode === EUserSuspendMode.SCHEDULE) {
        return data.date && new Date(data.date) > new Date();
      }
      return true;
    },
    {
      message: "Suspension date must be in the future.",
      path: ["date"],
    }
  );

export type UserSuspendUpdateDTO = z.infer<typeof UserSuspendUpdateDTOSchema>; 